module.exports = __webpack_public_path__ + "static/media/cross.f2a6a0e7.svg";